import { useCallback, useEffect, useState } from 'react';
import { useApi } from './useApi';
import { normalizeDocumentUsage, normalizeOcrUsage } from '../utils/planUsageDisplay';

export default function usePlanUsage({
  enabled = true,
  documentUsage = null,
  fetchRemote = false,
} = {}) {
  const { secureFetch } = useApi();
  const shouldFetch = enabled && (fetchRemote || !documentUsage);
  const [loading, setLoading] = useState(shouldFetch);
  const [documents, setDocuments] = useState(() => normalizeDocumentUsage(documentUsage));
  const [ocr, setOcr] = useState(null);
  const [error, setError] = useState('');

  const refresh = useCallback(async () => {
    if (!enabled) return;
    setLoading(true);
    setError('');
    try {
      const res = await secureFetch('/api/payments/overage/options');
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || 'No se pudo cargar el uso del plan');
      setDocuments(normalizeDocumentUsage(data.usage));
      setOcr(normalizeOcrUsage(data.ocrUsage));
    } catch (err) {
      setError(err.message || 'Error al cargar el uso del plan');
      if (documentUsage) {
        setDocuments(normalizeDocumentUsage(documentUsage));
      }
    } finally {
      setLoading(false);
    }
  }, [enabled, secureFetch, documentUsage]);

  useEffect(() => {
    if (documentUsage) {
      setDocuments(normalizeDocumentUsage(documentUsage));
    }
  }, [documentUsage]);

  useEffect(() => {
    if (!shouldFetch) {
      setLoading(false);
      return;
    }
    refresh();
  }, [shouldFetch, refresh]);

  return {
    documents,
    ocr,
    loading,
    error,
    refresh,
  };
}
